module.exports = __webpack_public_path__ + "img/splash_image.408b3a2b.png";